module.exports = __webpack_public_path__ + "img/mc-certificate-example-01.089fae73.svg";